import { combineReducers } from 'redux';
import {
  CREATE_SECTION,
  ADD_LINE_TO_SECTION,
  UPDATE_SECTION,
  DELETE_SECTION,
  REMOVE_LINE_FROM_SECTION,
  SWITCH_LINE_IN_SECTION,
} from '../actions/sections';
import { DELETE_LINE } from '../actions/line';

const defaultState = {
  label: '',
  type: '',
  lines: [],
};

const section = (state, action) => {
  switch (action.type) {
  case UPDATE_SECTION:
    return { ...state, ...action.obj };

  case ADD_LINE_TO_SECTION: {
    const newLines = [...state.lines];
    if (action.index === undefined) {
      newLines.push(action.lineId);
    } else {
      newLines.splice(action.index, 0, action.lineId);
    }
    return { ...state, lines: newLines };
  }

  case REMOVE_LINE_FROM_SECTION: {
    return {
      ...state,
      lines: state.lines.filter((id, index) => index !== action.index),
    };
  }

  case SWITCH_LINE_IN_SECTION: {
    return {
      ...state,
      lines: state.lines.map((lineId, index) => (index === action.index ? action.lineId : lineId)),
    };
  }

  default:
    return state;
  }
};

export default combineReducers({
  byId: (state = {}, action) => {
    switch (action.type) {
    case CREATE_SECTION: {
      return {
        ...state,
        [action.obj.id]: { ...defaultState, ...action.obj },
      };
    }
    case DELETE_SECTION: {
      const newState = { ...state };
      delete newState[action.id];
      return newState;
    }
    case UPDATE_SECTION:{
      return {
        ...state,
        [action.obj.id]: section(state[action.obj.id], action),
      };
    }
    case ADD_LINE_TO_SECTION: 
    case REMOVE_LINE_FROM_SECTION:
    case SWITCH_LINE_IN_SECTION: {
      return {
        ...state,
        [action.sectionId]: section(state[action.sectionId], action),
      };
    }

    case DELETE_LINE: {
      const newState = {};
      for (const sectionId of Object.keys(state)) {
        newState[sectionId] = {
          ...state[sectionId],
          lines: state[sectionId].lines.filter(x => x !== action.id),
        };
      }
      return newState;
    }

    default:
      return state;
    }
  },
  allIds: (state = [], action) => {
    switch (action.type) {
    case CREATE_SECTION: {
      const newState = [...state];
      if (action.index === undefined) {
        newState.push(action.obj.id);
      } else {
        newState.splice(action.index, 0, action.obj.id);
      }
      return newState;
    }

    default:
      return state;
    }
  },
});

// const sections = (state = { byId: {}, allIds: [] }, action) => {
//   switch (action.type) {
//   case CREATE_SECTION: {
//     return {
//       byId: {
//         ...state.byId,
//         [action.obj.id]: { ...defaultState, ...action.values, id: action.obj.id },
//       },
//       allIds: [...state.allIds, action.obj.id],
//     };
//   }

//   default:
//     return state;
//   }
// };

// export default sections;



// WEBPACK FOOTER //
// ./src/reducers/sections.js